import type { PartialSettingsNotifications } from "../user-preferences-notifications.type";
import type { UserPreferencesNotificationsTableColumnHeaderProps } from "./user-preferences-notifications-table-column-header.type";
import type { UserPreferencesNotificationsMenuItemOptions } from "../user-preferences-notifications-dropdown";

import { useUserPreferencesNotificationsDropdownBuilder } from "../user-preferences-notifications-dropdown";
import { useUserPreferencesNotificationsContext } from "../user-preferences-notifications.context";
import { getSettingChannelFromAction } from "../user-preferences-notifications.helper";

export const useUserPreferencesNotificationsTableColumnHeader = ({
  channel,
  notifications,
}: UserPreferencesNotificationsTableColumnHeaderProps) => {
  const { defaultSettings, onSettingsChange } =
    useUserPreferencesNotificationsContext();
  const { buildAction, buildDivider } =
    useUserPreferencesNotificationsDropdownBuilder();

  const menuItems = [
    buildAction("activate"),
    buildAction("disable"),
    buildDivider(),
    buildAction("reset"),
  ];

  const onMenuItemClick = ({
    action,
  }: UserPreferencesNotificationsMenuItemOptions) => {
    const newSettings: PartialSettingsNotifications = {};

    notifications.forEach((notification) => {
      const defaultValue = defaultSettings?.[notification.slug]?.[channel];
      const newValue = getSettingChannelFromAction(action, defaultValue);
      newSettings[notification.slug] = { [channel]: newValue };
    });

    onSettingsChange(newSettings);
  };

  return {
    channel,
    menuItems,
    onMenuItemClick,
  };
};
